import { getAppVersion } from '../app/services/version.service';

export const environment = {
  production: true,
  apiOrigin: 'https://api.internal.afterpic.ai',
  publicApiOrigin: 'https://api.afterpic.ai',
  appVersion: getAppVersion('+admin'),
  featureFlags: {
    showFinalPromptDebug: false,
  },
  mainAppUrl: 'https://afterpic.ai',
};
